export default "__VITE_ASSET__nTwUOnSj__"